import { Controller } from "@hotwired/stimulus"

const PROPAGATION_MAP = {
  // Round of 32 -> Round of 16
  "Round of 32 - Match 1": { target: "Round of 16 - Match 1", slot: "home" },
  "Round of 32 - Match 3": { target: "Round of 16 - Match 1", slot: "away" },
  
  "Round of 32 - Match 2": { target: "Round of 16 - Match 2", slot: "home" },
  "Round of 32 - Match 5": { target: "Round of 16 - Match 2", slot: "away" },
  
  "Round of 32 - Match 4": { target: "Round of 16 - Match 3", slot: "home" },
  "Round of 32 - Match 6": { target: "Round of 16 - Match 3", slot: "away" },
  
  "Round of 32 - Match 7": { target: "Round of 16 - Match 4", slot: "home" },
  "Round of 32 - Match 8": { target: "Round of 16 - Match 4", slot: "away" },
  
  "Round of 32 - Match 11": { target: "Round of 16 - Match 5", slot: "home" },
  "Round of 32 - Match 12": { target: "Round of 16 - Match 5", slot: "away" },
  
  "Round of 32 - Match 9": { target: "Round of 16 - Match 6", slot: "home" },
  "Round of 32 - Match 10": { target: "Round of 16 - Match 6", slot: "away" },
  
  "Round of 32 - Match 14": { target: "Round of 16 - Match 7", slot: "home" },
  "Round of 32 - Match 16": { target: "Round of 16 - Match 7", slot: "away" },
  
  "Round of 32 - Match 13": { target: "Round of 16 - Match 8", slot: "home" },
  "Round of 32 - Match 15": { target: "Round of 16 - Match 8", slot: "away" },

  // Round of 16 -> Quarter-finals
  "Round of 16 - Match 1": { target: "Quarter-finals - Match 1", slot: "home" },
  "Round of 16 - Match 2": { target: "Quarter-finals - Match 1", slot: "away" },
  "Round of 16 - Match 3": { target: "Quarter-finals - Match 2", slot: "home" },
  "Round of 16 - Match 4": { target: "Quarter-finals - Match 2", slot: "away" },
  "Round of 16 - Match 5": { target: "Quarter-finals - Match 3", slot: "home" },
  "Round of 16 - Match 6": { target: "Quarter-finals - Match 3", slot: "away" },
  "Round of 16 - Match 7": { target: "Quarter-finals - Match 4", slot: "home" },
  "Round of 16 - Match 8": { target: "Quarter-finals - Match 4", slot: "away" },

  // Quarter-finals -> Semi-finals
  "Quarter-finals - Match 1": { target: "Semi-finals - Match 1", slot: "home" },
  "Quarter-finals - Match 2": { target: "Semi-finals - Match 1", slot: "away" },
  "Quarter-finals - Match 3": { target: "Semi-finals - Match 2", slot: "home" },
  "Quarter-finals - Match 4": { target: "Semi-finals - Match 2", slot: "away" },

  // Semi-finals -> Final
  "Semi-finals - Match 1": { target: "Final", slot: "home" },
  "Semi-finals - Match 2": { target: "Final", slot: "away" }
}

function getPlaceholderName(stage) {
  if (stage.startsWith("Round of 32 - Match ")) {
    return "Ganador Dieciseisavos " + stage.replace("Round of 32 - Match ", "")
  } else if (stage.startsWith("Round of 16 - Match ")) {
    return "Ganador Octavos " + stage.replace("Round of 16 - Match ", "")
  } else if (stage.startsWith("Quarter-finals - Match ")) {
    return "Ganador Cuartos " + stage.replace("Quarter-finals - Match ", "")
  } else if (stage.startsWith("Semi-finals - Match ")) {
    return "Ganador Semis " + stage.replace("Semi-finals - Match ", "")
  }
  return "Ganador " + stage
}

export default class extends Controller {
  static targets = ["matchRow", "homeScore", "awayScore", "advancingTeam"]

  // Action triggered by the "✨ Autocompletar" button
  autocomplete(event) {
    if (event) event.preventDefault()

    // Sort rows by stage chronological order so that we predict previous rounds first,
    // which propagates the correct teams to the subsequent rounds before they get autocompleted!
    const sortedRows = [...this.matchRowTargets].sort((a, b) => {
      const stageA = a.dataset.stage || ""
      const stageB = b.dataset.stage || ""
      if (stageA.includes("Group") && !stageB.includes("Group")) return -1
      if (!stageA.includes("Group") && stageB.includes("Group")) return 1
      return stageA.localeCompare(stageB)
    })

    sortedRows.forEach(row => {
      const homeInput = row.querySelector("[data-quick-pick-target='homeScore']")
      const awayInput = row.querySelector("[data-quick-pick-target='awayScore']")
      const advancingSelect = row.querySelector("[data-quick-pick-target='advancingTeam']")

      if (homeInput && awayInput) {
        const homeRating = parseInt(row.dataset.homeRating, 10) || 50
        const awayRating = parseInt(row.dataset.awayRating, 10) || 50
        const isKnockout = row.dataset.isKnockout === "true"

        // Criterio A expected goals formula
        let homeLambda = 1.3 * Math.pow(homeRating / awayRating, 1.1)
        let awayLambda = 1.1 * Math.pow(awayRating / homeRating, 1.1)

        homeLambda = Math.max(0.2, Math.min(4.0, homeLambda))
        awayLambda = Math.max(0.2, Math.min(4.0, awayLambda))

        const homeGoals = this.poisson(homeLambda)
        const awayGoals = this.poisson(awayLambda)

        homeInput.value = homeGoals
        awayInput.value = awayGoals

        homeInput.dispatchEvent(new Event("change", { bubbles: true }))
        awayInput.dispatchEvent(new Event("change", { bubbles: true }))

        if (isKnockout && advancingSelect) {
          const homeTeamId = row.dataset.homeTeamId
          const awayTeamId = row.dataset.awayTeamId

          if (homeGoals > awayGoals) {
            advancingSelect.value = homeTeamId
          } else if (awayGoals > homeGoals) {
            advancingSelect.value = awayTeamId
          } else {
            const pHome = homeRating / (homeRating + awayRating)
            if (Math.random() < pHome) {
              advancingSelect.value = homeTeamId
            } else {
              advancingSelect.value = awayTeamId
            }
          }
          advancingSelect.dispatchEvent(new Event("change", { bubbles: true }))
        }
      }
    })
  }

  // Triggered when a score changes manually
  scoreChanged(event) {
    const input = event.currentTarget
    const row = input.closest("[data-quick-pick-target='matchRow']")
    if (!row) return

    const isKnockout = row.dataset.isKnockout === "true"
    if (!isKnockout) return

    const homeInput = row.querySelector("[data-quick-pick-target='homeScore']")
    const awayInput = row.querySelector("[data-quick-pick-target='awayScore']")
    const advancingSelect = row.querySelector("[data-quick-pick-target='advancingTeam']")

    if (homeInput && awayInput && advancingSelect) {
      const homeVal = homeInput.value.trim()
      const awayVal = awayInput.value.trim()

      if (homeVal !== "" && awayVal !== "") {
        const homeGoals = parseInt(homeVal, 10)
        const awayGoals = parseInt(awayVal, 10)
        const homeTeamId = row.dataset.homeTeamId
        const awayTeamId = row.dataset.awayTeamId

        let changed = false
        if (homeGoals > awayGoals && advancingSelect.value !== homeTeamId) {
          advancingSelect.value = homeTeamId
          changed = true
        } else if (awayGoals > homeGoals && advancingSelect.value !== awayTeamId) {
          advancingSelect.value = awayTeamId
          changed = true
        }

        if (changed) {
          advancingSelect.dispatchEvent(new Event("change", { bubbles: true }))
        }
      }
    }
  }

  // Triggered when advancing team selection is changed
  advancingTeamChanged(event) {
    const select = event.currentTarget
    const row = select.closest("[data-quick-pick-target='matchRow']")
    if (!row) return

    const advancingTeamId = select.value
    
    // 1. Propagate to subsequent stages in the forms
    this.propagateAdvancingTeam(row, advancingTeamId)

    // 2. Update stats prediction text in the corresponding visual bracket card
    this.updateBracketCardPrediction(row, advancingTeamId)
  }

  propagateAdvancingTeam(matchRow, advancingTeamId) {
    const stage = matchRow.dataset.stage
    const targetInfo = PROPAGATION_MAP[stage]
    if (!targetInfo) return

    const targetStage = targetInfo.target
    const slot = targetInfo.slot // "home" or "away"

    // Extract details of the advancing team
    let teamName = ""
    let teamEmoji = ""
    let teamRating = "50"

    const homeTeamId = matchRow.dataset.homeTeamId
    const awayTeamId = matchRow.dataset.awayTeamId

    if (advancingTeamId && advancingTeamId === homeTeamId) {
      teamName = matchRow.querySelector(".home-team-name").textContent.trim()
      teamEmoji = matchRow.querySelector(".home-team-flag").textContent.trim()
      teamRating = matchRow.dataset.homeRating || "50"
    } else if (advancingTeamId && advancingTeamId === awayTeamId) {
      teamName = matchRow.querySelector(".away-team-name").textContent.trim()
      teamEmoji = matchRow.querySelector(".away-team-flag").textContent.trim()
      teamRating = matchRow.dataset.awayRating || "50"
    } else {
      // Revert to placeholder team
      teamName = getPlaceholderName(stage)
      teamEmoji = "❓"
      teamRating = "50"
    }

    // Update form match rows across both main list and "all matches" list
    const targetRows = document.querySelectorAll(`[data-quick-pick-target='matchRow'][data-stage='${targetStage}']`)
    targetRows.forEach(targetRow => {
      // Update datasets
      if (slot === "home") {
        targetRow.dataset.homeTeamId = advancingTeamId || ""
        targetRow.dataset.homeRating = teamRating
        
        const homeNameSpan = targetRow.querySelector(".home-team-name")
        if (homeNameSpan) homeNameSpan.textContent = teamName
        
        const homeFlagSpan = targetRow.querySelector(".home-team-flag")
        if (homeFlagSpan) homeFlagSpan.textContent = teamEmoji
      } else {
        targetRow.dataset.awayTeamId = advancingTeamId || ""
        targetRow.dataset.awayRating = teamRating
        
        const awayNameSpan = targetRow.querySelector(".away-team-name")
        if (awayNameSpan) awayNameSpan.textContent = teamName
        
        const awayFlagSpan = targetRow.querySelector(".away-team-flag")
        if (awayFlagSpan) awayFlagSpan.textContent = teamEmoji
      }

      // Re-populate select options
      const select = targetRow.querySelector("[data-quick-pick-target='advancingTeam']")
      if (select) {
        const prevValue = select.value
        const hId = targetRow.dataset.homeTeamId
        const aId = targetRow.dataset.awayTeamId
        const hName = targetRow.querySelector(".home-team-name").textContent.trim()
        const aName = targetRow.querySelector(".away-team-name").textContent.trim()

        select.innerHTML = `
          <option value="">Avanza...</option>
          <option value="${hId}">${hName}</option>
          <option value="${aId}">${aName}</option>
        `

        // Preserve previous selection if still valid
        if (prevValue && (prevValue === hId || prevValue === aId)) {
          select.value = prevValue
        } else {
          // Check if scores already exist and determine winner
          const homeInput = targetRow.querySelector("[data-quick-pick-target='homeScore']")
          const awayInput = targetRow.querySelector("[data-quick-pick-target='awayScore']")
          if (homeInput && awayInput && homeInput.value.trim() !== "" && awayInput.value.trim() !== "") {
            const hVal = parseInt(homeInput.value.trim(), 10)
            const aVal = parseInt(awayInput.value.trim(), 10)
            if (hVal > aVal) {
              select.value = hId
            } else if (aVal > hVal) {
              select.value = aId
            } else {
              select.value = ""
            }
          } else {
            select.value = ""
          }
        }
        
    // Trigger select change recursively to propagate all the way up
        select.dispatchEvent(new Event("change", { bubbles: true }))
      }
    })
  }

  updateBracketCardPrediction(matchRow, advancingTeamId) {
    const matchId = matchRow.dataset.matchId
    const homeInput = matchRow.querySelector("[data-quick-pick-target='homeScore']")
    const awayInput = matchRow.querySelector("[data-quick-pick-target='awayScore']")
    if (!homeInput || !awayInput) return

    const homeVal = homeInput.value.trim()
    const awayVal = awayInput.value.trim()

    const cards = document.querySelectorAll(`[data-bracket-match-id='${matchId}']`)
    cards.forEach(card => {
      const scoreRow = card.querySelector(".prediction-score-row")
      const scoreSpan = card.querySelector(".prediction-score")
      const advancingRow = card.querySelector(".prediction-advancing-row")
      const advancingTeamSpan = card.querySelector(".prediction-advancing-team")
      const noPredRow = card.querySelector(".no-prediction-row")

      if (homeVal !== "" && awayVal !== "") {
        if (scoreSpan) scoreSpan.textContent = `${homeVal} - ${awayVal}`
        if (scoreRow) scoreRow.classList.remove("hidden")
        if (noPredRow) noPredRow.classList.add("hidden")

        if (advancingTeamId) {
          let teamName = ""
          let teamEmoji = ""
          if (advancingTeamId === matchRow.dataset.homeTeamId) {
            teamName = matchRow.querySelector(".home-team-name").textContent.trim()
            teamEmoji = matchRow.querySelector(".home-team-flag").textContent.trim()
          } else if (advancingTeamId === matchRow.dataset.awayTeamId) {
            teamName = matchRow.querySelector(".away-team-name").textContent.trim()
            teamEmoji = matchRow.querySelector(".away-team-flag").textContent.trim()
          }

          // Check if the teamName is a participant in the current card
          const cardHomeName = card.querySelector("[data-bracket-team-slot='home'] .team-name")?.textContent?.trim()
          const cardAwayName = card.querySelector("[data-bracket-team-slot='away'] .team-name")?.textContent?.trim()
          const isParticipant = (teamName && (teamName === cardHomeName || teamName === cardAwayName))

          if (isParticipant && teamName && advancingTeamSpan) {
            const flagSpan = advancingTeamSpan.querySelector(".advancing-flag")
            const nameSpan = advancingTeamSpan.querySelector(".advancing-name")
            if (flagSpan) flagSpan.textContent = teamEmoji
            if (nameSpan) nameSpan.textContent = teamName
            if (advancingRow) advancingRow.classList.remove("hidden")
          } else {
            if (advancingRow) advancingRow.classList.add("hidden")
          }
        } else {
          if (advancingRow) advancingRow.classList.add("hidden")
        }
      } else {
        if (scoreRow) scoreRow.classList.add("hidden")
        if (advancingRow) advancingRow.classList.add("hidden")
        if (noPredRow) noPredRow.classList.remove("hidden")
      }
    })
  }

  // Poisson random variable generator (Knuth's method)
  poisson(lambda) {
    const L = Math.exp(-lambda)
    let k = 0
    let p = 1.0

    do {
      k++
      p *= Math.random()
    } while (p > L && k < 20)

    return k - 1
  }
}
